import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const AppleIcon = () => (
  <svg width="22" height="22" viewBox="0 0 384 512" fill="currentColor" style={{ marginRight: '10px' }}>
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
  </svg>
);

// Swapped to the much cleaner Material Design Android logo
const AndroidIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '10px' }}>
    <path d="M17.6,9.48l1.84-3.18c0.16-0.31,0.04-0.69-0.26-0.85c-0.29-0.15-0.65-0.06-0.81,0.22l-1.88,3.24 c-2.86-1.21-6.08-1.21-8.94,0L5.67,5.67c-0.16-0.28-0.52-0.37-0.81-0.22C4.56,5.6,4.44,5.98,4.6,6.3L6.44,9.48 C3.3,11.25,1.28,14.44,1,18h22C22.72,14.44,20.7,11.25,17.6,9.48z M7,15.25c-0.69,0-1.25-0.56-1.25-1.25S6.31,12.75,7,12.75 S8.25,13.31,8.25,14S7.69,15.25,7,15.25z M17,15.25c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25 S17.69,15.25,17,15.25z"/>
  </svg>
);

function Home() {
  return (
    <>
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <h1 style={styles.title}>CheerClip</h1>
          <p style={styles.subtitle}>Detect stunts. Cut videos.</p>
          <p style={styles.description}>
            Save time and level up your cheer edits — all powered by AI.
          </p>

          <div style={styles.buttonContainer}>
            <a
              href="https://apps.apple.com/us/app/cheerclip/id6743004433"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.ctaButton}
            >
              <AppleIcon />
              App Store
            </a>
            
            <a
              href="https://play.google.com/store/apps/details?id=com.cheerclip.app"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.ctaButton}
            >
              <AndroidIcon />
              Google Play
            </a>
          </div>

          <p style={styles.secondaryText}>
            Prefer desktop?{' '}
            <a
              href="https://app.cheerclip.com"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Open Web Version
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

const styles = {
  wrapper: {
    height: '100vh',
    background: 'linear-gradient(135deg, #e6fffa, #ffffff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Segoe UI', sans-serif",
    paddingBottom: '4rem',
  },
  card: {
    background: 'white',
    padding: '3rem',
    borderRadius: '16px',
    boxShadow: '0 12px 28px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: '3rem',
    color: '#234e52',
    marginBottom: '1rem',
    marginTop: 0,
  },
  subtitle: {
    fontSize: '1.5rem',
    color: '#319795',
    marginBottom: '1rem',
  },
  description: {
    fontSize: '1rem',
    color: '#4a5568',
    marginBottom: '2rem',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '2rem',
    alignItems: 'center',
  },
  ctaButton: {
    backgroundColor: '#319795',
    color: '#fff',
    padding: '1rem 1.5rem',
    borderRadius: '10px',
    fontSize: '1.1rem',
    fontWeight: '500',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '280px', // Slightly narrowed since the text is shorter
    boxSizing: 'border-box',
    transition: 'background-color 0.2s ease-in-out',
  },
  secondaryText: {
    fontSize: '0.9rem',
    color: '#2c7a7b',
  },
  link: {
    color: '#2c7a7b',
    textDecoration: 'underline',
  },
};

export default Home;